export const isLocalItemExpired = (item, override) => {
  if (!item || !item.timestamp) return true;

  const now = new Date();
  const timestamp = new Date(item.timestamp);
  const timeout = override || 4; // hours

  if (now.setHours(now.getHours() - timeout) < timestamp) {
    return false;
  }

  return true;
}

const checkLocalStorage = () => {
  const test = 'test';
  try {
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch(e) {
    return false;
  }
}

export const getLocalItem = label => {
  if (!checkLocalStorage()) return false;

  const item = localStorage.getItem(label);
  return JSON.parse(item);
}

export const setLocalItem = (label, data) => {
  if (!checkLocalStorage()) return false;

  localStorage.setItem(label, JSON.stringify(data));
}

export const removeLocalItem = label => {
  localStorage.removeItem(label);
}
